// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".output-preview .ant-tabs-tabpane .k-widget.k-spreadsheet {\n  padding-top: 0px;\n}\n", "",{"version":3,"sources":["webpack://src/modules/data_crafter_app/components/OutputPreview/OutputPreview.less"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".output-preview .ant-tabs-tabpane .k-widget.k-spreadsheet {\n  padding-top: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
